import React, { useEffect, useState } from 'react';
import { dmClient } from '../../services/dmClient';
import './admin.css';

export default function AuditPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    dmClient.get('/audit', { params: { limit: 200 } })
      .then((r) => setItems(r.data?.data?.items || []))
      .catch((e) => setError(e?.response?.data?.error || e.message || 'Failed to load audit log'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-head">
        <div>
          <h1>Audit log</h1>
          <p>Security-relevant actions across your organization (no PHI is recorded).</p>
        </div>
      </div>

      {error && <div className="admin-alert admin-alert--error">{error}</div>}

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr><th>Time</th><th>Actor</th><th>Action</th><th>Resource</th><th>IP</th></tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="admin-empty">Loading…</td></tr>}
            {!loading && items.length === 0 && (
              <tr><td colSpan={5} className="admin-empty">No audit events yet.</td></tr>
            )}
            {!loading && items.map((a) => (
              <tr key={a.AuditId}>
                <td>{a.CreatedAt ? new Date(a.CreatedAt).toLocaleString() : '—'}</td>
                <td>{a.Actor || '—'}</td>
                <td><code className="admin-mono">{a.Action}</code></td>
                <td>
                  {a.ResourceType ? `${a.ResourceType}` : '—'}
                  {a.ResourceId ? <span className="admin-hint"> {String(a.ResourceId).slice(0, 12)}</span> : null}
                </td>
                <td>{a.IpAddress || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
